export const NAME = 'customers';